// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { ham as _ham } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the ham chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 5112
 * Chain Name: Ham
 * Default Block Explorer: https://explorer.ham.fun
 * Default RPC URL: https://rpc.ham.fun
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { ham } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: ham,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const ham = createCommon({
	..._ham,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
